<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="_1-CN" id="_idParaDest-1"><span class="leading-139-5"><img alt="" class="_idGenObjectAttribute-1" src="image/LoveLikeBlood_042517.png"/></span> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBookVR0245.vue?7b83fcb6